import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getTodos } from '../../nucleo/api';
import type { DepositoOpcao } from './tipos';
import { TextoCortado } from '../../componentes/texto-cortado';

/** Linha de "rótulo e valor" das fichas. */
export function Linha({ rotulo, children }: { rotulo: string; children: ReactNode }) {
  const { t } = useTranslation();
  const vazio = children === '' || children === null || children === undefined || children === false;
  return (
    <div className="flex min-w-0 justify-between gap-4 py-1.5 text-sm">
      <dt className="shrink-0 text-tinta-3">{rotulo}</dt>
      <TextoCortado como="dd" className={`min-w-0 text-right ${vazio ? 'text-tinta-3' : ''}`}>{vazio ? t('comum.naoInformado') : children}</TextoCortado>
    </div>
  );
}

export function Secao({ titulo, acao, children }: { titulo: string; acao?: ReactNode; children: ReactNode }) {
  return (
    <section className="mt-6 min-w-0">
      <div className="mb-2 flex min-w-0 items-center justify-between gap-3">
        <h3 className="kicker">{titulo}</h3>
        {acao}
      </div>
      {children}
    </section>
  );
}

/** Depósitos do Estoque para escolher onde a mercadoria chega. */
export function useDepositos(habilitado = true) {
  return useQuery({
    queryKey: ['/estoque/depositos', 'opcoes'],
    queryFn: () => getTodos<DepositoOpcao>('/estoque/depositos', { ativo: true }),
    enabled: habilitado,
    staleTime: 30_000,
  });
}

/** Rótulo de produto nas buscas remotas: código e nome. */
export const rotuloProduto = (i: Record<string, unknown>) => `${String(i.codigo)} ${String(i.nome)}`;
